module.exports = __webpack_public_path__ + "static/media/Mockup_bettilt.656133e4.png";